import React, { ReactElement, useState, useEffect, Fragment,
    useRef, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { IAppState } from '@/store/reducers'
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import { Modal, Space, Input, Image, Button, List, Typography,
    Skeleton, Avatar, message, Tabs } from 'antd'
// import type { MenuProps } from 'antd'
import { SearchOutlined, DoubleRightOutlined, ExclamationCircleOutlined,
    FormOutlined, PlusCircleOutlined, IssuesCloseOutlined, DeleteOutlined,
} from '@ant-design/icons'
import type { TableColumnsType } from 'antd'
import { useTranslation } from 'react-i18next'
// import ResizableTable from '@/components/resizableTable'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { marked, } from 'marked'
// import { v4 as uuidv4 } from 'uuid'
import { splitStream, debounce, copyToClipboard, } from '@/utils/util'
import { throttle } from 'lodash'
import { useHistory } from 'react-router-dom'
import { postPrompt, createSession, getSessionRecord, getSessionAll,
    zanMessage, caiMessage, delMessage, editSessionName, delSession, saveAnswer,
    controller as postQuestionController, summary,
} from '@/services/rag'
import DefaultContent from '@/pages/rag/components/defaultCon'
import IconComp from '@/pages/rag/components/icon'
import { ImgSrc } from '@/pages/rag/components/qaSimple'
import EditQuestion from '@/pages/rag/components/editQuestion'
import DefaultHeadImg from '@/assets/images/defaultHeadImg.jpg'
import BatchRelativeTech from '@/pages/rag/components/batchRelativeTech'

type listData = {
    ptnId: number
    ptn: string
    score: number
}
interface IMessage {
    chatId: number
    content: string
    parentId: number
    role: 'user' | 'assistant'
    vote: number
    question?: string // 问题
    userImg: string // 用户头像
    listData: {
        tableData: listData[], // 链接列表
        columns: any[]
    }
    productDemandList?: any[]
    loading: boolean
    answer?: string // 流式输出
    $tokens: any[]
    messageId: number | undefined
    isAdd: boolean
    isEdit?: boolean
    generating?: boolean
    likeComment?: string
    dislikeComment?: string
    childrenIds?: (string | number)[]
    isSummary?: 0 | 1
}

function sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

const renderer = new marked.Renderer()
const { ...defaults } = marked.getDefaults()

// type MenuItem = Required<MenuProps>['items'][number];
// function getItem(
//     label: React.ReactNode,
//     key: React.Key,
//     icon?: React.ReactNode,
//     children?: MenuItem[],
//     type?: 'group',
// ): MenuItem {
//     return {
//         key,
//         icon,
//         children,
//         label,
//         type,
//     } as MenuItem
// }

// 过滤 tpnList 中 ptnId === -1 的列表
const filterTpnList = (productDemandList: {
    messageId: number
    productDemandId: number
    productDemandName: string
    tpnInfoList: listData[]
}[]) => {
    const tableData: any[] = []
    const columns: TableColumnsType<{
        productDemandName: string
    } & {
        [ptn: string]: {
            ptnId: string
            ptn: string
            scope: number
        }
    }> = [{
        title: '需求',
        dataIndex: 'productDemandName',
        fixed: true,
        width: 200
    }]
    const mapObj = new Map()
    productDemandList.forEach(productDemand => {
        const tableItem: any = {
            productDemandName: productDemand.productDemandName
        };
        (productDemand.tpnInfoList || []).forEach((ptnItem: listData) => {
            if (ptnItem.ptnId !== -1) {
                // 提取出所有技术方案
                if(!(mapObj.get(ptnItem.ptnId))) {
                    mapObj.set(ptnItem.ptnId, ptnItem)
                }
                tableItem[ptnItem.ptn] = {
                    ptnId: ptnItem.ptnId,
                    ptn: ptnItem.ptn,
                    scope: ptnItem.score
                }
            }
        })
        tableData.push(tableItem)
    })
    const firstRow: any = {
        productDemandName: '',
    }
    for (const [, ptnItem] of mapObj) {
        firstRow[ptnItem.ptn] = {
            ptnId: ptnItem.ptnId,
            ptn: ptnItem.ptn,
            scope: ptnItem.score
        }
        columns.push({
            title: ptnItem.ptn,
            dataIndex: ptnItem.ptn,
            align: 'center',
            width: 150,
            render (value, record, index) {
                if (value) {
                    if (index === 0) {
                        return <a href={`/projectInfoView?workGroupId=1&projectId=${value.ptnId}&isView=true`}
                            target='_blank'
                        >
                            <Typography.Text
                                style={{ marginLeft: 20, textDecoration: 'underline', color: '#036fc0' }}
                            >{value.ptn}</Typography.Text>
                        </a>
                    } else {
                        return <span>{value ? value.scope.toFixed(2) : ''}</span>
                    }
                } else {
                    return <></>
                }
            }
        })
    }
    if (Object.keys(firstRow).length > 1) {
        tableData.unshift(firstRow)
    }
    return {
        tableData,
        columns
    }
}

const QuestionComp = (props: {
    winH: number
    isModalOpen: boolean
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    setIsModalOpen: (value: boolean) => void
}): ReactElement => {
    const { isModalOpen, setIsModalOpen, winH } = props

    const { confirm } = Modal

    const history = useHistory()
    const { t, i18n } = useTranslation()
    const userInfo = useSelector((state: IAppState) => state.auth.userInfo)
    const [sessionId, setSessionId] = useState<number | null>(null)
    const [searchKey, setSearchKey] = useState('')
    const [historyList, setHistoryList] = useState<any>({})
    const [messages, setMessages] = useState<IMessage[]>([])
    const [messagesLen, setMessagesLen] = useState(0)
    const [loading, setLoading] = useState(false) // 提问时的 loading，控制输入框和提交按钮
    const [initLoading, setInitLoading] = useState(false)
    const [autoQuestion, setAutoQuestion] = useState<any>(null)
    const [showToBottom, setShowToBottom] = useState(false) // 显示滚动到最底部的图标
    const [editSessionText, setEditSessionText] = useState('')
    const [editSessionId, setEditSessionId] = useState<number | null>(null)
    const [isModalOpenModiSession, setIsModalOpenModiSession] = useState(false)
    const [enableScroll, setEnableScroll] = useState(false)
    const [winW, setWinW] = useState(0)
    const [sessionList, setSessionList] = useState<{
        chatId: number
        chatTitle: string
    }[]>([])
    const [curTab, setCurTab] = useState('1')

    const containerRef = useRef<any>(null)
    const textareaRef = useRef<any>(null)
    const readerRef = useRef<any>(null)
    // 如果正在流式输出，此时切换会话
    const changeSession = useRef(true)

    // const [menuItems, ] = useState([
    //     getItem('创建新会话', 'sub1', <PlusCircleOutlined />),
    //     getItem('历史会话', 'sub2', <IssuesCloseOutlined />, [
    //         getItem('Item 1', 'g1', <AppstoreOutlined />),
    //         getItem('Item 2', 'g2', <AppstoreOutlined />),
    //     ])
    // ])
    // const onClickMenu: MenuProps['onClick'] = e => {
    //     console.log('click', e)
    //     if (e.key === 'sub1') {
    //         createSessionFn('clear')
    //     }
    // }

    const tabsItems = [{
        label: t('process') + (i18n.language !== 'zh' ? ' ' : '') + t('assistant'),
        key: '1'
    }, {
        label: t('process') + (i18n.language !== 'zh' ? ' ' : '') + t('batch') + (i18n.language !== 'zh' ? ' ' : '') + t('relative'),
        key: '2'
    }]
    const onChangeTabs = (key: string) => setCurTab(key)

    const handleOk = () => {
        setIsModalOpen(false)
    }
    const handleCancel = () => {
        setIsModalOpen(false)
    }
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const goTechDetail = (ptnId: number) => {
        history.push(`/projectInfoView?workGroupId=1&projectId=${ptnId}&isView=true`)
    }

    const hasPtnList = useCallback((productDemandList: any[] | undefined) =>
        productDemandList?.find(item => item?.tpnInfoList && item.tpnInfoList.length > 0)
    , [])

    const scrollBottom = useCallback(throttle(() => {
        if (containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight
        }
    }, 50), [containerRef.current])
    // 手动点击滚动到底部按钮，恢复自动滚动
    const handleScrollBottom = useCallback(() => {
        setEnableScroll(true)
        scrollBottom()
    }, [])
    // 用户手动滚动
    const onScroll = useCallback(debounce(() => {
        // 用户手动滚动后，不再自动滚动
        setEnableScroll(false)
    }, 1000, true), [])

    const onScrollContainer = useCallback(throttle((e: any) => {
        setShowToBottom(e.target.scrollTop < e.target.scrollHeight - (winH - 260) - 10
            && messages.length > 0)
    }, 500), [winH, messages])

    const onCopy = useCallback(async (messageId: number) => {
        console.log('messageId: ', messageId)
        const findObj = messages.find(message => message.messageId === messageId)
        if (findObj) {
            const res = await copyToClipboard(findObj.content)
            if (res) {
                message.success('复制成功')
            }
        }
    }, [messages])
    const onZan = useCallback(async (messageId: number, comment: string) => {
        const findObj = messages.find(message => message.messageId === messageId)
        if (findObj) {
            const res = await zanMessage(messageId, comment)
            console.log('zan res: ', res)
            findObj.vote = 1
            setMessages([...messages])
        }
    }, [messages])
    const onCai = useCallback(async (messageId: number, comment: string) => {
        const findObj = messages.find(message => message.messageId === messageId)
        if (findObj) {
            const res = await caiMessage(messageId, comment)
            console.log('cai res: ', res)
            findObj.vote = -1
            setMessages([...messages])
        }
    }, [messages])
    // 删除提问消息
    const onDel = useCallback(async (messageId: number) => {
        const findObj = messages.find(message => message.messageId === messageId)
        if (findObj) {
            const res = await delMessage(messageId)
            console.log('del res: ', res)
            sessionId && getSessionMessages(sessionId)
            message.success('删除成功')
        }
    }, [messages])
    // 中断生成
    const onCancelGenerate = useCallback(async (messageId: number) => {
        const findObj = messages.find(message => message.messageId === messageId)
        if (findObj) {
            findObj.generating = false
        }
        postQuestionController.abort()
        readerRef.current.cancel()
    }, [messages])

    // 判断是否最后一条回答
    const isLastAnswer = useCallback((index: number): boolean => {
        if (index === messagesLen - 1) {
            return true
        } else {
            // 是否后续还有 answer
            let hasAnswer = false
            index++
            while (messages[index]) {
                if (messages[index].isSummary !== 1 && messages[index].role === 'assistant') {
                    hasAnswer = true
                    break
                }
                index++
            }
            return !hasAnswer
        }
    }, [messages])
    // 编辑用户填写问题
    const onEditUserQuestion = useCallback((messageId: number) => {
        console.log('messageId: ', messageId)
        const findObj = messages.find(message => message.messageId === messageId)
        if (findObj) {
            findObj.isEdit = true
        }
        setMessages([...messages.slice(0, (messages.length > 1 ? messages.length - 1 : undefined))])
    }, [messages])
    // 编辑生成内容
    const onEditAnswer = useCallback((messageId: number) => {
        messages.some(message => {
            if (message.messageId === messageId) {
                message.isEdit = true
                return true
            }
        })
    }, [messages])
    // 重新发送用户问题
    const reSendQuestion = async (messageId: number, editContent: string) => {
        const arr: (IMessage)[] = []
        messages.some(message => {
            if (message.messageId === messageId) {
                message.isEdit = false
                message.question = editContent
                const questionMessage = {
                    ...message,
                    content: editContent,
                    messageId: -1
                }
                arr.push(questionMessage)
                // 更新 historyList
                const parentNode = historyList[message.parentId]
                if (parentNode && parentNode.childrenIds) {
                    parentNode.childrenIds.push(-1)
                }
                historyList[-1] = questionMessage
                setHistoryList({ ...historyList })
                return true
            } else {
                arr.push({
                    ...message,
                })
            }
            return false
        })
        console.log('arr: ', arr)
        // 找到当前条所在位置
        const newMessages = arr.slice(0, arr.length - 1)
        console.log('newMessage: ', newMessages)
        setMessages([...newMessages])
        sendHotQuestion(editContent)
    }
    // 保存 生成内容 编辑
    const onSaveEditAnswer = async (messageId: number, editContent: string) => {
        const findObj = messages.find(message => message.messageId === messageId)
        if (findObj) {
            findObj.isEdit = false
            findObj.answer = editContent
            findObj.content = editContent
            await saveAnswer({
                messageId,
                content: editContent
            })
            const $tokens = marked.lexer(editContent)
            findObj.$tokens = $tokens
            setMessages([...messages])
        }
    }
    const reSendCancel = (messageId: number) => {
        const findObj = messages.find(message => message.messageId === messageId)
        if (findObj) {
            findObj.isEdit = false
        }
        // 还原 原数据
        const newMessages = [...messages]
        const findHistory = messages[messages.length - 1]
        whileFindChild(findHistory, newMessages)
        setMessages([...newMessages])
        setMessagesLen(newMessages.length)
    }

    // 创新一个新会话
    const createSessionFn = (str?: string) => {
        if (!changeSession.current) {
            return
        }
        setInitLoading(true)
        createSession()
            .then((res: any) => {
                setSessionId(res.chatId)
                localStorage.setItem('ragSessionId', res.chatId)
                // 点击创建新会话
                if (str === 'clear') {
                    setMessages([])
                    setMessagesLen(0)
                    setHistoryList({})
                    getSessionAllFn()
                } else if (str === 'new') {
                    setSessionId(res.chatId)
                    setSessionList([{
                        chatId: res.chatId,
                        chatTitle: res.chatTitle
                    }])
                }
            })
            .finally(() => {
                setInitLoading(false)
            })
    }

    // 通过 history 以及当前 row id 获取 childrens
    const getChildrenNum = useCallback((rowId: number) => {
        let findObj = historyList[rowId]
        if (findObj) {
            if (findObj.parentId !== 0) {
                if (findObj) {
                    findObj = historyList[findObj.parentId]
                }
                return findObj?.childrenIds?.length ?? 0
            } else {
                // 如果是第一个问题，则取 parentId === 0 的列表
                const arr: IMessage[] = Object.values(historyList)
                const rootArr = arr.filter(item => item.parentId === 0)
                return rootArr.length
            }
        }
        return 0
    }, [historyList])
    // 匹配当前条是在父级的子节点中的索引
    const getChildIndex = useCallback((rowId: number) => {
        // 找到父级
        const parentId = historyList[rowId]?.parentId
        if (parentId === 0) {
            let i = 0
            Object.values(historyList).some((item: any) => {
                if (item.parentId === 0) {
                    i++
                }
                if (item.messageId === rowId) {
                    return true
                }
            })
            return i
        }
        const parentNode = historyList[parentId]
        return parentNode?.childrenIds ? parentNode.childrenIds.indexOf(rowId) + 1 : 1
    }, [historyList])

    // 处理 listData 和 tokens
    const handleMessage = (message: IMessage) => {
        if (message.role === 'user') {
            return {
                ...message,
                question: message.content,
                userImg: userInfo?.avatar || DefaultHeadImg,
            }
        } else {
            const $tokens = marked.lexer(message.content)
            const listData = message.productDemandList ? filterTpnList(message.productDemandList) : message.listData
            return {
                ...message,
                answer: message.content,
                listData,
                $tokens
            }
        }
    }
    // 一直往下寻找子节点
    const whileFindChild = useCallback((findHistory: any, newMessages: IMessage[]) => {
        while (findHistory) {
            if (findHistory.childrenIds?.length > 0) {
                const childLen = findHistory.childrenIds.length
                const curPageId = findHistory.childrenIds[childLen - 1]
                findHistory = historyList[curPageId]
                newMessages.push(handleMessage(findHistory))
            } else {
                break
            }
        }
    }, [historyList])

    const getHistoryAnswer = useCallback((messageId: number, page: number) => {
        console.log('getHistoryAnswer: ', messageId, page)
        let newMessages: IMessage[] = []
        let findHistory = historyList[messageId]
        const findIndex = messages.findIndex(item => item.messageId === messageId)
        if (findIndex !== -1) {
            // 先把当前条及之前的全部放到 messages
            newMessages = messages.slice(0, findIndex)
        }
        // 再找到当前条兄弟节点的第 page 个放入 messages
        const parentNode = historyList[findHistory.parentId]
        const curPageId = parentNode.childrenIds[page - 1]
        findHistory = historyList[curPageId]
        const findMessage = newMessages.find(message => message.messageId === findHistory.messageId)
        if (!findMessage) {
            newMessages.push(handleMessage(findHistory))
        }
        whileFindChild(findHistory, newMessages)
        console.log('newMessages: ', newMessages)
        setMessages([...newMessages])
        setMessagesLen(newMessages.length)
    }, [messages, historyList])
    const getHistoryQuestion = useCallback((messageId: number, page: number) => {
        const newMessages: IMessage[] = []
        let findHistory = historyList[messageId]
        // 第一条提问需要单独处理, 在 history 中找到当前条的 childrenIds ，再根据 page 获取第 几个 id，找到对应的数据内容
        if (findHistory.parentId === 0) {
            // 找到 parentId 为 0 的第 page 个
            const rootArr = Object.values(historyList).filter((item: any) => 
                item.parentId === 0
            )
            // 找到要切换到的
            findHistory = rootArr[page - 1]
            // 先把当前条添加到 messages，作为第1条
            newMessages.push(handleMessage(findHistory))
            whileFindChild(findHistory, newMessages)
            console.log('newMessages: ', newMessages)
            setMessages([...newMessages])
            setMessagesLen(newMessages.length)
        } else {
            getHistoryAnswer(messageId, page)
        }
    }, [messages, historyList])

    // 获取指定 sessionId 会话 提问列表
    const getSessionMessages = async (sessionId: number) => {
        setInitLoading(true)
        setMessages([])
        setMessagesLen(0)
        const resData = await getSessionRecord(sessionId)
            .finally(() => {
                setInitLoading(false)
            })
        if (resData.history) {
            setHistoryList(resData.history || {})
        }
        if (resData.messages) {
            const newMessages = resData.messages.map((item: any) => {
                if (item.role === 'user') {
                    return {
                        ...item,
                        question: item.content,
                        messageId: item.messageId,
                        isAdd: false,
                        userImg: userInfo?.avatar || DefaultHeadImg,
                    }
                } else {
                    const $tokens = marked.lexer(
                        item.content
                    )
                    return {
                        ...item,
                        answer: item.content,
                        listData: filterTpnList(item.productDemandList),
                        messageId: item.messageId,
                        loading: false,
                        $tokens,
                        isAdd: false,
                    }
                }
            })
            
            setEnableScroll(true)
            setMessages(newMessages)
            setMessagesLen(newMessages.length)
            setTimeout(() => {
                setEnableScroll(false)
            }, 100)
        } else {
            setMessages([])
            setMessagesLen(0)
        }
    }

    // 处理流式显示
    const streamShow = async (parmas: {
        reader: any
        prevMessages: IMessage[]
        questionMessage?: IMessage
        answerMessage: IMessage
    }) => {
        const { reader, prevMessages, questionMessage, answerMessage } = parmas
        let initTime = Date.now()
        // 通过流式获取数据，解析后更新渲染
        let { value, done } = await reader.read()
        console.log('done: ', done, JSON.stringify(answerMessage))
        while (!done) {
            try {
                const lines = value.split('\n')
                for (const line of lines) {
                    if (line !== '') {
                        const data = JSON.parse(line)
                        let flag = false
                        if (questionMessage?.messageId && questionMessage.messageId < 0) {
                            questionMessage.messageId = data.parentId
                            if (questionMessage.childrenIds) {
                                questionMessage.childrenIds.push(data.messageId)
                            } else {
                                questionMessage.childrenIds = [data.messageId]
                            }
                            // 更新 historyList
                            historyList[-1] && delete historyList[-1]
                            historyList[data.parentId] = questionMessage
                            // 如果父级 childrenIds 有 -1 ，则删除
                            const parentNode = historyList[historyList[data.parentId].parentId]
                            if (parentNode && parentNode.childrenIds) {
                                const findIndex = parentNode.childrenIds.findIndex((child: number) => child === -1)
                                if (findIndex !== -1) {
                                    parentNode.childrenIds.splice(findIndex, 1)
                                }
                                // 把新的问题 messageId 放到 问题父级的 childrenIds 中
                                parentNode.childrenIds.push(data.parentId)
                                flag = true
                            }
                        }
                        if (answerMessage.messageId === -2 || answerMessage.messageId === -3) {
                            answerMessage.messageId = data.messageId
                            answerMessage.parentId = data.parentId
                            answerMessage.isSummary = data.isSummary
                            // 更新 historyList
                            historyList[-2] && delete historyList[-2]
                            historyList[-3] && delete historyList[-3]
                            historyList[data.messageId] = answerMessage
                            // 如果父级 childrenIds 有 -2 ，则删除
                            const parentNode2 = historyList[data.parentId]
                            if (parentNode2) {
                                let findIndex2 = parentNode2.childrenIds?.findIndex((child: number) => child === -2)
                                if (findIndex2 && findIndex2 !== -1) {
                                    parentNode2.childrenIds?.splice(findIndex2, 1)
                                }
                                findIndex2 = parentNode2.childrenIds?.findIndex((child: number) => child === -3)
                                if (findIndex2 && findIndex2 !== -1) {
                                    parentNode2.childrenIds?.splice(findIndex2, 1)
                                }
                                if (parentNode2.childrenIds) {
                                    if (!parentNode2.childrenIds.includes(data.messageId)) {
                                        parentNode2.childrenIds.push(data.messageId)
                                    }
                                } else {
                                    parentNode2.childrenIds = [data.messageId]
                                }
                                flag = true
                            }
                        }
                        if (flag) {
                            console.log('historyList: ', { ...historyList })
                            setHistoryList({ ...historyList })
                        }
                        if ('productDemandList' in data) {
                            answerMessage.listData = filterTpnList(data.productDemandList)
                            console.log('data.productDemandList: ', data.productDemandList)
                            answerMessage.productDemandList = data.productDemandList
                        } else {
                            answerMessage.answer += data.content
                            answerMessage.content = answerMessage?.answer ?? ''
                            const $tokens = marked.lexer(
                                answerMessage.content
                            )
                            answerMessage.$tokens = $tokens
                        }
                        let newMessages: IMessage[] = []
                        if (questionMessage) {
                            newMessages = [...prevMessages, questionMessage, answerMessage]
                        } else {
                            newMessages = [...prevMessages, answerMessage]
                        }
                        setMessages(newMessages)
                        setMessagesLen(newMessages.length)
                        const curTime = Date.now()
                        if (curTime - initTime < 10) {
                            await sleep(10)
                            initTime = Date.now()
                        }
                    }
                }

                const readRes = await reader.read()
                value = readRes.value
                done = readRes.done
                console.log('done: ', done, value)
            } catch (error) {
                console.log(error)
                break
            }
        }
        // 流式输出完成，此时不再自动滚动到底部
        setEnableScroll(false)
        setSearchKey('')
        setLoading(false)
        // 流式输出完成，此时可以切换会话
        changeSession.current = true
        answerMessage.generating = false
    }

    // 发送问题请求
    const sendPostQuestion = async (params: {
        prevMessages: IMessage[],
        questionMessage: IMessage,
        answerMessage: IMessage
        postMessages: IMessage[]
    }) => {
        const { prevMessages, questionMessage, answerMessage, postMessages } = params
        setLoading(true)
        if (sessionId !== null) {
            try {
                const res = await postPrompt({
                    chatId: sessionId,
                    messages: postMessages
                })
                answerMessage.loading = false
                if (res && res.ok) {
                    const reader = res.body
                        .pipeThrough(new window.TextDecoderStream())
                        .pipeThrough(splitStream('\n'))
                        .getReader()
                    readerRef.current = reader
                    streamShow({ reader, prevMessages, questionMessage, answerMessage })
                } else {
                    answerMessage.generating = false
                    answerMessage.content = '请求出错，请重新再试'
                    const $tokens = marked.lexer(
                        answerMessage.content
                    )
                    answerMessage.$tokens = $tokens
                    let newMessages: IMessage[] = []
                    questionMessage.childrenIds = historyList[questionMessage?.messageId ?? '']?.childrenIds
                    if (questionMessage) {
                        newMessages = [...prevMessages, questionMessage, answerMessage]
                    } else {
                        newMessages = [...prevMessages, answerMessage]
                    }
                    if (questionMessage.messageId) {
                        if (!historyList[questionMessage.messageId]) {
                            historyList[questionMessage.messageId] = questionMessage
                            historyList[questionMessage.messageId].childrenIds = []
                        }
                        answerMessage.parentId = questionMessage.messageId
                    }
                    setMessages(newMessages)
                    setMessagesLen(newMessages.length)
                    setLoading(false)
                    setEnableScroll(false)
                    setSearchKey('')
                    setLoading(false)
                    // 流式输出完成，此时可以切换会话
                    changeSession.current = true
                    answerMessage.generating = false
                }
            } catch (e) {
                console.log('e: ', e)
                answerMessage.loading = false
            }
        } else {
            setLoading(false)
        }
    }
    // 发送问题
    const onSubmitPrompt = async () => {
        console.log('submit: ', searchKey)
        // 点击热点问题自动提交
        setAutoQuestion(null)
        setEnableScroll(true)
        // 发送时，禁止切换会话
        changeSession.current = false
        const prevMessages = [...messages]
        const prevMessage = messages.pop()
        // 问题显示
        const questionMessage: IMessage = {
            chatId: Number(sessionId),
            content: searchKey,
            parentId: prevMessage?.messageId ?? 0,
            role: 'user',
            vote: 0,
            question: searchKey,
            userImg: userInfo?.avatar || DefaultHeadImg,
            loading: false,
            answer: '',
            listData: {
                tableData: [],
                columns: []
            },
            $tokens: [],
            messageId: -1,
            isAdd: true,
        }
        // 回答显示
        const answerMessage: IMessage = {
            chatId: Number(sessionId),
            content: '',
            parentId: prevMessage?.messageId ?? 0,
            role: 'assistant',
            vote: 0,
            userImg: userInfo?.avatar || DefaultHeadImg,
            loading: true,
            answer: '',
            listData: {
                tableData: [],
                columns: []
            },
            $tokens: [],
            messageId: -2,
            isAdd: true,
            generating: true,
        }
        // 更新显示，回答显示loading
        const newMessages = [...prevMessages, questionMessage, answerMessage]
        setMessages(newMessages)
        setMessagesLen(newMessages.length)
        const postMessages: any[] = [
            ...prevMessages.map(message => ({
                ...message,
                chatId: message.chatId,
            })),
            {
                chatId: sessionId,
                content: searchKey,
                parentId: prevMessage?.messageId ?? 0,
                role: 'user',
                vote: Number(0),
                isSummary: 0
            }
        ]
        // 发送问题请求
        sendPostQuestion({
            prevMessages, postMessages, questionMessage, answerMessage
        })
        // 如果是第一个问题，则设置会话标题为问题前几个字
        if (prevMessages.length === 0) {
            const newTitle = questionMessage.question?.substring(0, 15) ?? ''
            editSessionConfirm(null, { sessionIdParam: sessionId || 0, titleParam: newTitle })
        }
    }
    // 重新生成
    const onGenerate = async (messageId: number) => {
        const findObj = messages.find(message => message.messageId === messageId)
        if (findObj) {
            // 重新生成总结
            if (findObj.isSummary) {
                onSummary(findObj.parentId, 'isReGenerate')
                return
            }
            const findParentIndex = messages.findIndex(message => message.messageId === findObj.parentId)
            // while (findParentIndex !== -1) {
            //     if (messages[findParentIndex].role === 'assistant') {
            //         findParentIndex--
            //     } else {
            //         break
            //     }
            // }
            if (findParentIndex !== -1) {
                const prevMessages = messages.slice(0, findParentIndex)
                const prevMessage = messages[findParentIndex]
                // 更新 historyList
                if (prevMessage.messageId) {
                    console.log('historyList[prevMessage.messageId]: ', historyList[prevMessage.messageId])
                    const findObj = historyList[prevMessage.messageId].childrenIds.find((item: any) => item === -2)
                    if (!findObj) {
                        historyList[prevMessage.messageId].childrenIds.push(-2)
                    }
                }
                // 回答显示
                const answerMessage: IMessage = {
                    chatId: Number(sessionId),
                    content: '',
                    parentId: prevMessage?.messageId ?? 0,
                    role: 'assistant',
                    vote: 0,
                    userImg: userInfo?.avatar || DefaultHeadImg,
                    loading: true,
                    answer: '',
                    listData: {
                        tableData: [],
                        columns: []
                    },
                    $tokens: [],
                    messageId: -2,
                    isAdd: true,
                    generating: true
                }
                const postMessages = [...prevMessages, prevMessage]
                console.log('postMessages: ', postMessages)
                const newMessage = [...postMessages, answerMessage]
                setMessages(newMessage)
                setMessagesLen(newMessage.length)
                // 更新 historyList
                historyList[-2] = answerMessage
                console.log('historyList: ', historyList)
                setHistoryList({ ...historyList })

                setEnableScroll(true)
                // 发送时，禁止切换会话
                changeSession.current = false
                // 发送问题请求
                sendPostQuestion({
                    prevMessages,
                    postMessages,
                    questionMessage: prevMessage,
                    answerMessage
                })
            }
        }
    }
    // 总结输出
    const onSummary = async (messageId: number, isReGenerate?: string) => {
        const findObj = messages.find(message => message.messageId === messageId)
        if (findObj) {
            setEnableScroll(true)
            // 发送时，禁止切换会话
            changeSession.current = false
            const prevMessages = [...messages]

            // 如果是重新生成，把当前生成条目 删除，
            if (isReGenerate === 'isReGenerate') {
                prevMessages.pop()
            }
            // 回答显示
            const answerMessage: IMessage = {
                chatId: Number(sessionId),
                content: '',
                parentId: findObj.messageId ?? 0,
                role: 'assistant',
                vote: 0,
                userImg: userInfo?.avatar || DefaultHeadImg,
                loading: true,
                answer: '',
                listData: {
                    tableData: [],
                    columns: []
                },
                $tokens: [],
                messageId: -3,
                isSummary: 1,
                isAdd: true,
                generating: true,
            }
            const newMessages = [...prevMessages, answerMessage]
            setMessages(newMessages)
            setMessagesLen(newMessages.length)
            setLoading(true)
            const res = await summary({
                chatId: Number(sessionId),
                messages: [findObj]
            })
            answerMessage.loading = false
            if (res && res.ok) {
                const reader = res.body
                    .pipeThrough(new window.TextDecoderStream())
                    .pipeThrough(splitStream('\n'))
                    .getReader()
                readerRef.current = reader
                streamShow({ reader, prevMessages, answerMessage })
            } else {
                answerMessage.generating = false
                answerMessage.isSummary = 1
                answerMessage.content = '请求出错，请重新再试'
                const $tokens = marked.lexer(
                    answerMessage.content
                )
                answerMessage.$tokens = $tokens
                historyList[-3] = answerMessage
                const questionMessage = newMessages[newMessages.length - 2]
                if (questionMessage.messageId) {
                    if (!historyList[questionMessage.messageId]) {
                        historyList[questionMessage.messageId] = questionMessage
                        if (!historyList[questionMessage.messageId].childrenIds) {
                            historyList[questionMessage.messageId].childrenIds = []
                        }
                    }
                    if (!historyList[questionMessage.messageId].childrenIds.includes(-3)) {
                        historyList[questionMessage.messageId].childrenIds.push(-3)
                    }
                    answerMessage.parentId = questionMessage.messageId
                    newMessages.some(item => {
                        if (item.messageId === answerMessage.parentId) {
                            item.childrenIds = historyList[answerMessage.parentId].childrenIds
                            return true
                        }
                    })
                }
                setMessages(newMessages)
                setMessagesLen(newMessages.length)
                setLoading(false)
                setEnableScroll(false)
                setSearchKey('')
                setLoading(false)
                // 流式输出完成，此时可以切换会话
                changeSession.current = true
                answerMessage.generating = false
            }
        }
    }

    // 获取全部会话记录
    const getSessionAllFn = async () => {
        getSessionAll()
            .then(resData => {
                const newSessionList = resData.reverse()
                console.log('newSessionList: ', newSessionList)
                setSessionList(newSessionList)
                let sessionIdT: number
                if (newSessionList.length > 0) {
                    const oldSessionId = localStorage.getItem('ragSessionId')
                    if (!oldSessionId) {
                        // 使用最新一条
                        sessionIdT = newSessionList[0].chatId
                    } else {
                        sessionIdT = Number(oldSessionId)
                        const findObj = newSessionList.find(sessionItem => sessionItem.chatId === sessionIdT)
                        if (!findObj) {
                            // 历史记录 id 未找到，则使用最新一条
                            sessionIdT = newSessionList[0].chatId
                        }
                    }
                    setSessionId(sessionIdT)
                    localStorage.setItem('ragSessionId', String(sessionIdT))
                    getSessionMessages(sessionIdT)
                } else {
                    createSessionFn('new')
                }
            })
    }

    // 点击热门问题
    const sendHotQuestion = (question: string) => {
        setSearchKey(question)
        setAutoQuestion(question)
    }

    // 修改会话名称 弹窗输入内容
    const changeEditSessionText = (e: any) => {
        setEditSessionText(e.target.value)
    }
    // 编辑会话记录
    const editSession = (sessionIdParam: number) => {
        const findObj = sessionList.find(sessionItem => sessionItem.chatId === sessionIdParam)
        if (findObj) {
            setEditSessionText(findObj.chatTitle)
            setEditSessionId(findObj.chatId)
            setIsModalOpenModiSession(true)
        }
    }
    // 编辑会话记录确认
    const editSessionConfirm = (e: any, params?: {
        sessionIdParam: number
        titleParam: string
    }) => {
        const { sessionIdParam, titleParam } = params ?? {}
        let sId: number | undefined
        let title: string | undefined
        if (sessionIdParam) {
            sId = sessionIdParam
        } else if (editSessionId) {
            sId = editSessionId
        }
        if (titleParam) {
            title = titleParam
        } else if (editSessionText) {
            title = editSessionText
        }
        if (sId) {
            const findObj = sessionList.find(sessionItem => sessionItem.chatId === sId)
            if (findObj) {
                findObj.chatTitle = title ?? ''
                // 调用保存接口
                editSessionName({
                    chatId: sId,
                    title: title ?? ''
                })
                setSessionList([...sessionList])
            }
        }
        setIsModalOpenModiSession(false)
    }
    const cancelDeleteSession = () => {
        setIsModalOpenModiSession(false)
    }
    // 删除会话记录
    const deleteSession = (sessionIdParam: number) => {
        confirm({
            title: '删除会话?',
            icon: <ExclamationCircleOutlined />,
            content: '本条会话数据将被永久删除，不可恢复及撤销。确定要删除吗？',
            centered: true,
            async onOk() {
                // 中断生成
                postQuestionController?.abort()
                readerRef.current?.cancel()

                await delSession(sessionIdParam)
                message.success('删除成功')
                const findIndex = sessionList.findIndex(sessionItem => sessionItem.chatId === sessionIdParam)
                sessionList.splice(findIndex, 1)
                if (sessionList.length > 0) {
                    setSessionList([...sessionList])
                    // 删除后设置选中项
                    if (sessionId === sessionIdParam) {
                        let newSessionId: number
                        if (sessionList[findIndex]) {
                            newSessionId = sessionList[findIndex].chatId
                            setSessionId(newSessionId)
                            localStorage.setItem('ragSessionId', String(newSessionId))
                            getSessionMessages(newSessionId)
                        } else if (sessionList[findIndex - 1]) {
                            newSessionId = sessionList[findIndex - 1].chatId
                            setSessionId(newSessionId)
                            localStorage.setItem('ragSessionId', String(newSessionId))
                            getSessionMessages(newSessionId)
                        }
                    }
                } else {
                    setInitLoading(true)
                    setMessages([])
                    createSessionFn('clear')
                }
            },
            onCancel() {
                console.log('Cancel')
            },
        })
    }
    // 是否是最后一条提问
    const isLastQuestionFn = useCallback((messageId: number) => {
        const messagesT = messages.slice()
        let lastQuestion = messagesT.pop()
        while (lastQuestion) {
            if (lastQuestion.role === 'user') {
                break
            } else {
                lastQuestion = messagesT.pop()
            }
        }
        return messageId === lastQuestion?.messageId
    }, [messages])

    useEffect(() => {
        const offset = 395
        let winWT = Math.floor(document.body.clientWidth * 0.8 - offset)
        setWinW(winWT)
        const onResize = () => {
            winWT = Math.floor(document.body.clientWidth * 0.8 - offset)
            setWinW(winWT)
        }
        window.addEventListener('resize', onResize)
        return () => {
            window.removeEventListener('resize', onResize)
        }
    }, [])
    useEffect(() => {
        if (isModalOpen) {
            // 获取全部会话记录
            getSessionAllFn()
        }
    }, [isModalOpen])
    useEffect(() => {
        if (containerRef.current) {
            if (isModalOpen && enableScroll) {
                scrollBottom()
            }
            // 用户手动操作鼠标滚动
            containerRef.current.addEventListener('wheel', onScroll)
            return () => {
                containerRef.current?.removeEventListener('wheel', onScroll)
            }
        }
    }, [messages, isModalOpen, enableScroll])
    useEffect(() => {
        if (autoQuestion) {
            onSubmitPrompt()
        }
    }, [autoQuestion])

    return (<><Modal
        title={<>
            <Tabs className='assistant_tabs'
                activeKey={curTab}
                onChange={onChangeTabs}
            >
                {tabsItems.map(tab =>
                    <Tabs.TabPane tab={tab.label} key={tab.key} />
                )}
            </Tabs>
        </>}
        footer={null}
        visible={isModalOpen}
        maskClosable={false}
        onOk={handleOk}
        onCancel={handleCancel}
        width='80%'
        style={{ top: 20, padding: 0, maxWidth: '80%' }}
        className='question_modal'
    >
        <Space align='start' className='question_box' style={{ width: '100%', display: curTab === '1' ? '' : 'none' }}>
            <div style={{ alignSelf: 'stretch', paddingRight: 10, height: '100%', borderRight: '1px #efefef solid' }}>
                {sessionId !== null &&
                    <Button type='primary' icon={
                        <PlusCircleOutlined />
                    } onClick={() => {
                        createSessionFn('clear')
                    }}>创建新会话</Button>
                }
                <List className='session_history'
                    style={{ height: winH - 167 }}
                    size="large"
                    pagination={false}
                    dataSource={sessionList}
                    footer={false}
                    locale={{ emptyText: '' }}
                    renderItem={item => (
                        <List.Item
                            className={item.chatId === sessionId ? 'cur' : ''}
                            onClick={() => {
                                if (changeSession.current && item.chatId !== sessionId) {
                                    getSessionMessages(item.chatId)
                                    setSessionId(item.chatId)
                                    localStorage.setItem('ragSessionId', String(item.chatId))
                                }
                            }}
                            key={item.chatId}
                            actions={[
                                <FormOutlined key="list-vertical-star-o" style={{ fontSize: 15 }}
                                    onClick={(e: any) => {
                                        e.stopPropagation()
                                        if (changeSession.current) {
                                            editSession(item.chatId)
                                        }
                                    }}
                                />,
                                <DeleteOutlined key="list-vertical-like-o" style={{ fontSize: 15 }}
                                    onClick={(e: any) => {
                                        e.stopPropagation()
                                        if (changeSession.current) {
                                            deleteSession(item.chatId)
                                        }
                                    }}
                                />
                            ]}
                        >
                            <IssuesCloseOutlined /> {item.chatTitle}
                        </List.Item>
                    )}
                />
            </div>
            <div style={{ position: 'relative', paddingTop: 15, height: winH - 130, }}>
                <div ref={containerRef}
                    style={{ marginBottom: 10, width: winW + 50, height: winH - 250, overflowY: 'auto' }}
                    onScroll={onScrollContainer}
                >
                    <Space direction='vertical' size={15} style={{ width: '100%' }}>
                        {initLoading
                            ? <Skeleton active paragraph={{ rows: 4 }} />
                            : (messagesLen === 0 ? <DefaultContent sendHotQuestion={sendHotQuestion} /> : <></>)
                        }
                        {messages.map((item, index) => (
                            <Fragment key={item.messageId}>
                                {'question' in item
                                    ? <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: 5, width: '100%' }}>
                                        {!item?.isEdit ? (<>
                                            <div className='question' style={{ width: winW - 45 }}>
                                                <div className='user_question'>
                                                    { item.question }
                                                </div>
                                                {/* 编辑操作按钮 */}
                                                <IconComp isUser messageId={item.messageId ?? 0}
                                                    isLastQuestion={isLastQuestionFn(item.messageId ?? 0)}
                                                    onEditUserQuestion={onEditUserQuestion}
                                                    onCopy={onCopy}
                                                    onDel={onDel}
                                                    pageIndex={() => getChildIndex(item.messageId ?? 0)}
                                                    pageNums={() => getChildrenNum(item.messageId ?? 0)}
                                                    getHistoryQuestion={getHistoryQuestion}
                                                />
                                            </div>
                                            <Image src={item.userImg} width={30} preview={false} />
                                        </>) : (<>
                                            {/* 编辑问题重新发送 */}
                                            <EditQuestion messageId={item.messageId ?? 0}
                                                content={item.content}
                                                reSend={reSendQuestion}
                                                reSendCancel={reSendCancel}
                                            />
                                        </>)
                                        }
                                    </div>
                                    : (!item.isEdit ? <div style={{ display: 'flex', width: 'calc(100% - 40px)' }}>
                                        <Image src={ImgSrc} width={50} preview={false} />
                                        <Space direction='vertical' size={5} style={{ width: winW }}>
                                            {/* 匹配到的技术列表 */}
                                            {/* {item.isSummary === 1 && item.listData.tableData.length > 0 && <div style={{ width: winW - 50 }}>
                                                <ResizableTable size='small'
                                                    tableData={item.listData.tableData}
                                                    cols={item.listData.columns}
                                                    pagination={false}
                                                    showHeader={false}
                                                    rowKey='productDemandName'
                                                    scroll={{ x: 'max-content' }}
                                                />
                                            </div>} */}
                                            
                                            {hasPtnList(item.productDemandList) && <List
                                                className="product_demand_list"
                                                itemLayout="horizontal"
                                                rowKey="productDemandId"
                                                dataSource={item.productDemandList}
                                                style={{ backgroundColor: '#fff' }}
                                                size='small'
                                                renderItem={item => (
                                                    <List.Item>
                                                        <List.Item.Meta
                                                            avatar={<div style={{ width: 250 }}>
                                                                <a key={item.productDemandId}
                                                                    style={{ fontWeight: 'bold', textDecoration: 'underline', color: 'rgb(3, 111, 192)', display: 'inline-block' }}
                                                                    href={`/addVote?title=${item.productDemandName}&description=${
                                                                        item.description ? encodeURIComponent(item.description) : ''
                                                                    }`}
                                                                    target='_blank'
                                                                >
                                                                    {item.productDemandName}
                                                                </a>
                                                            </div>}
                                                            title={item.tpnInfoList?.map((tpnItem: any) => (
                                                                <a key={tpnItem.ptnId}
                                                                    style={{ marginLeft: 20, textDecoration: 'underline', color: 'rgb(3, 111, 192)', display: 'inline-block' }}
                                                                    href={`/projectInfoView?workGroupId=1&projectId=${tpnItem.ptnId}&isView=true`}
                                                                    target='_blank'
                                                                >
                                                                    {tpnItem.ptn} &nbsp; ({Number(tpnItem.score.toFixed(2))})
                                                                </a>
                                                            ))}
                                                        />
                                                    </List.Item>
                                                )}
                                            />}
                                            {/* 回答显示 */}
                                            {item.loading ? <Skeleton active paragraph={{ rows: 4 }} />
                                                : <div className={`answer ${isLastAnswer(index) ? 'often_show' : ''}`}>
                                                    {item.$tokens?.map((token: any, index) => {
                                                        const newDefault = {
                                                            ...defaults
                                                        }
                                                        // newDefault.mangle = false
                                                        // newDefault.headerIds = false
                                                        const htmlStr = marked.parse(token.raw, {
                                                            ...newDefault,
                                                            gfm: true,
                                                            breaks: true,
                                                            renderer
                                                        })
                                                        return <div key={`${item.messageId}_${index}`}
                                                            dangerouslySetInnerHTML={{
                                                                __html: htmlStr as string
                                                            }}
                                                        >
                                                        </div>
                                                    })}
                                                    {/* 操作按钮 */}
                                                    <IconComp messageId={item.messageId ?? 0}
                                                        isLastAnswer={isLastAnswer(index)}
                                                        isLast={index === messagesLen - 1}
                                                        onEditAnswer={() => onEditAnswer(item.messageId ?? 0)}
                                                        onCopy={onCopy}
                                                        onZan={onZan}
                                                        onCai={onCai}
                                                        vote={item.vote}
                                                        onGenerate={onGenerate}
                                                        onStop={onCancelGenerate}
                                                        onSummary={onSummary}
                                                        generating={item.generating}
                                                        zanComment={item.likeComment}
                                                        caiComment={item.dislikeComment}
                                                        isSummary={item.isSummary}
                                                        pageIndex={() => getChildIndex(item.messageId ?? 0)}
                                                        pageNums={() => getChildrenNum(item.messageId ?? 0)}
                                                        getHistoryAnswer={getHistoryAnswer}
                                                    />
                                                </div>
                                            }
                                        </Space>
                                    </div> : <>
                                        {/* 编辑生成答案 */}
                                        <EditQuestion messageId={item.messageId ?? 0}
                                            content={item.content}
                                            reSend={onSaveEditAnswer}
                                            reSendCancel={reSendCancel}
                                            isAnswer={item.role === 'assistant'}
                                        />
                                    </>)}
                            </Fragment>
                        ))}
                    </Space>
                </div>
                {showToBottom && <span onClick={handleScrollBottom}>
                    <Avatar className='to_bottom'
                        icon={
                            <DoubleRightOutlined
                                style={{ color: '#2d65f7', transform: 'rotate(90deg)' }}
                            />
                        }
                    />
                </span>}
                <div className='search_box'>
                    <Input.TextArea placeholder="Enter your question"
                        disabled={loading}
                        bordered={false}
                        rows={2}
                        style={{ resize: 'none' }}
                        className='question_input'
                        value={searchKey}
                        ref={textareaRef}
                        onChange={(e) => { setSearchKey(e.target.value) }}
                        // ctrl + enter 换行， enter 提交
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault()
                                if (e.ctrlKey) {
                                // 换行
                                    setSearchKey(searchKey + '\n')
                                } else {
                                // 提交
                                    onSubmitPrompt()
                                }
                            }
                        }}
                    />
                    <div className={`search_btn ${searchKey ? '' : 'gray'}`}>
                        <Button className={loading ? 'loading send' : 'send'}
                            loading={loading}
                            icon={
                                <SearchOutlined
                                    className='search_icon2'
                                />
                            } onClick={onSubmitPrompt}
                        />
                    </div>
                </div>
            </div>
        </Space>

        <div style={{ width: '100%', display: curTab === '2' ? '' : 'none' }}>
            <BatchRelativeTech winH={winH} />
        </div>
    </Modal>
    <Modal title='修改会话名称'
        visible={isModalOpenModiSession}
        maskClosable={false}
        onOk={editSessionConfirm}
        onCancel={cancelDeleteSession}
        width={500}
        zIndex={1010}
        style={{ top: 0, padding: 0, maxWidth: '80%' }}
        centered
    >
        <Input value={editSessionText} onChange={changeEditSessionText} />
    </Modal>
    </>)
}
export default QuestionComp